import { IS_PRODUCT } from "@/constants";

export const HFOX_MIXIN_RECIPENT = IS_PRODUCT
  ? "3ec8c231-f5a2-4081-af15-e2eac80db745"
  : "78c968aa-3dbd-4f69-8792-4ff0bedbcb11";

export const USDT_ASSET_ID = "31d2ea9c-95eb-3355-b65b-ba096853bc18";

export const BOX_ASSET_ID = "f5ef6b5d-cc5a-3d90-b2c0-a2fd386e7a3c";

export const USDT_ASSET = {
  id: "31d2ea9c-95eb-3355-b65b-ba096853bc18",
  symbol: "pUSD",
  alia: "pUSD",
  name: "Pando USD",
  chain_id: "43d61dcd-e413-450d-80b8-101d5e903357",
  logo:
    "https://mixin-images.zeromesh.net/cH4GWuPXbzeZl6OOunpn7BxE25n3v8URwnNszs0FpZqv3OTlxP1zpzKw89VKTpBwWL-Ned1R36mmy1C4GMuPX1rL-PjfEJ2zby9V=s128"
};

export const SCHEDULE_USE_LINK =
  "https://fox.zendesk.com/hc/zh-cn/articles/360040485611";

export const LP_PLAN_LINK =
  "https://docs.pando.im/docs/lake/key-concepts/lp-token";

export const SWAP_GROUP_URL =
  "https://mixin.one/users/2e71a662-54b8-4c22-a76a-fabdaa81711a";

export const TOUSHI_AUTH_URL = IS_PRODUCT
  ? "https://toushi-view.fox.one/#/auth"
  : "https://toushi-view-test.fox.one/#/auth";

export const TOUSHI_AUTH_CLIENT_ID = IS_PRODUCT
  ? "f301e126-a474-45e0-8759-b3b37b67e04c"
  : "c7d01382-fc65-402f-85c2-dc85c53ea571";
